@if (CanAdminister()) {
  <header class="list-header"><div><h2>Reviewers</h2>@if (!loading && !errorMessage) {<p class="list-count">{{profiles?.length || 0}} {{profiles?.length === 1 ? 'reviewer' : 'reviewers'}}</p>}</div></header>
  @if (loading) {<p class="list-state" role="status">Loading reviewers…</p>}
  @else if (errorMessage) {<div class="list-state error" role="alert"><p>{{errorMessage}}</p><button class="list-button" (click)="getProfiles()">Retry</button></div>}
  @else if (!profiles?.length) {<p class="list-state" role="status">No reviewers available.</p>}
  @else {<ul class="entity-list">@for (profile of profiles; track profile.type + ':' + profile.id) {
    <li class="entity-tile">
      <h3><a [routerLink]="['/review/profile/', profile.type, profile.id]">{{profile.social?.name?.trim() || 'Name not available'}}</a></h3>
      <p>{{profile.social?.email?.trim() || 'Email not available'}}</p>
      <dl class="tile-meta">
        <div><dt>Profile ID</dt><dd>{{profile.id}}</dd></div>
        <div><dt>Profile type</dt><dd>{{profile.type === 1 ? 'Google' : profile.type === 2 ? 'Fake' : 'Unknown'}} ({{profile.type}})</dd></div>
        <div><dt>Global review</dt><dd>{{profile.review == null ? 'Not available' : profile.review ? 'Allowed' : 'Not granted'}}</dd></div>
        <div><dt>Global administration</dt><dd>{{profile.administer == null ? 'Not available' : profile.administer ? 'Allowed' : 'Not granted'}}</dd></div>
      </dl>
    </li>
  }</ul>}
} @else {<p class="list-state">Not an administrator.</p>}
